import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import { getValueFromLanguageObject, loadUserDetailsFromLocalStorage } from "../../../store";
import { connect } from "react-redux";
import { checkAuthAndRedirect, getCurrentPath } from "../../../utils/cartRedirect";
import { navigateTo } from "../../../utils/utils";

class Sitemap extends Component {
  state = {
    mainPages: [
      { name: "Home", url: "/", requiresAuth: false },

    ],
    accountPages: [
      { name: "My Profile", url: "/myprofile", requiresAuth: true },
      { name: "Order History", url: "/orders", requiresAuth: true },
      { name: "Wish List", url: "/wishlist", requiresAuth: true },
      { name: "Cart", url: "/cart", requiresAuth: true },
      { name: "Compare", url: "/compare", requiresAuth: true },
      { name: "Reward Points", url: "/rewardpoints", requiresAuth: true },
      { name: "Address Book", url: "/address", requiresAuth: true }
      // { name: "Settings", url: "/settings", requiresAuth: true }
    ],
    infoPages: [
      { name: "About Us", url: "/aboutus", requiresAuth: false },
      { name: "Contact Us", url: "/contactus", requiresAuth: false },
      { name: "Terms & Conditions", url: "/termsandconditions", requiresAuth: false },
      { name: "FAQ", url: "/faq", requiresAuth: false }
    ]
  };

  componentDidMount() {
    // Redirect to login if not authenticated
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!userDetails) {
      navigateTo(this.props, `/login`);
    }
  }

  render() {
  // Rendering is controlled by route-level protection. Keep per-link click-time checks as they
  // may still be useful for conditionally pushing to login when user interacts with a protected link.

    const { mainPages, accountPages, infoPages } = this.state;

    return (
      <>
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" type="image/x-icon" href={process.env.PUBLIC_URL + `/assets/images/icon/favicon_razerewards.png`} />
          <title>
            {getValueFromLanguageObject("str_sitemap")
              ? getValueFromLanguageObject("str_sitemap")
              : "Sitemap"}
          </title>
          <meta
            name="description"
            content="Sitemap - Find all pages and sections of our website"
          />
        </Helmet>

        <Breadcrumb
          title={
            getValueFromLanguageObject("str_sitemap")
              ? getValueFromLanguageObject("str_sitemap")
              : "Sitemap"
          }
        />

        <section className="section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {/* Main Pages */}
                  <div className="col-md-4 mb-4">
                    <div className="sitemap-section">
                      <h4 className="section-title mb-3">
                        <i className="fa fa-home mr-2"></i>
                        {getValueFromLanguageObject("str_main_pages") || "Main Pages"}
                      </h4>
                      <ul className="sitemap-list">
                        {mainPages.map((page, index) => (
                          <li key={index}>
                            <span 
                              onClick={() => {
                                if (page.requiresAuth) {
                                  const currentPath = getCurrentPath(this.props);
                                  if (checkAuthAndRedirect(this.props, currentPath)) {
                                    this.props.history.push(page.url);
                                  }
                                } else {
                                  this.props.history.push(page.url);
                                }
                              }}
                              className="sitemap-link"
                              style={{ cursor: 'pointer' }}
                            >
                              {page.name}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* My Account */}
                  <div className="col-md-4 mb-4">
                    <div className="sitemap-section">
                      <h4 className="section-title mb-3">
                        <i className="fa fa-user mr-2"></i>
                        {getValueFromLanguageObject("str_my_account") || "My Account"}
                      </h4>
                      <ul className="sitemap-list">
                        {accountPages.map((page, index) => (
                          <li key={index}>
                            <span 
                              onClick={() => {
                                if (page.requiresAuth) {
                                  const currentPath = getCurrentPath(this.props);
                                  if (checkAuthAndRedirect(this.props, currentPath)) {
                                    this.props.history.push(page.url);
                                  }
                                } else {
                                  this.props.history.push(page.url);
                                }
                              }}
                              className="sitemap-link"
                              style={{ cursor: 'pointer' }}
                            >
                              {page.name}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Information */}
                  <div className="col-md-4 mb-4">
                    <div className="sitemap-section">
                      <h4 className="section-title mb-3">
                        <i className="fa fa-info-circle mr-2"></i>
                        {getValueFromLanguageObject("str_information") || "Information"}
                      </h4>
                      <ul className="sitemap-list">
                        {infoPages.map((page, index) => (
                          <li key={index}>
                            <span 
                              onClick={() => {
                                if (page.requiresAuth) {
                                  const currentPath = getCurrentPath(this.props);
                                  if (checkAuthAndRedirect(this.props, currentPath)) {
                                    this.props.history.push(page.url);
                                  }
                                } else {
                                  this.props.history.push(page.url);
                                }
                              }}
                              className="sitemap-link"
                              style={{ cursor: 'pointer' }}
                            >
                              {page.name}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <style jsx>{`
          .sitemap-section {
            background: #f8f9fa;
            padding: 20px;
            border-radius: 8px;
            height: 100%;
            border: 1px solid #e9ecef;
          }
          
          .section-title {
            color: #333;
            font-size: 18px;
            font-weight: 600;
            border-bottom: 2px solid #1252c9;
            padding-bottom: 10px;
          }
          
          .sitemap-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          
          .sitemap-list li {
            margin-bottom: 2px;
            position: relative;
            padding-left: 20px;
            line-height: 1.5;
            display: block;
          }
          
          .sitemap-list li::before {
            content: "●";
            position: absolute;
            left: 0;
            top: 2px;
            color: #1252c9;
            font-size: 12px;
            font-weight: bold;
          }
          
          .sitemap-link {
            color: #1252c9;
            text-decoration: none;
            font-size: 14px;
            transition: color 0.3s ease;
            display: block;
            padding: 2px 0;
          }
          
          .sitemap-link:hover {
            color: #0056b3;
            text-decoration: underline;
          }
        `}</style>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  // Add any state mappings if needed
});

export default connect(mapStateToProps, {})(Sitemap);